<template>
  <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div
        class="modal-container"
        :class="{
          review_modal: positionChecker() === 'stepReview',
          personal_data_modal: positionChecker() === 'stepPersonalData',
        }"
      >
        <!-- Close Modal -->
        <div v-if="positionChecker() === 'stepClose'" class="modal-inner">
          <div class="modal-header mb-2">
            <img
              src="../../../public/images/pgx-logo.png"
              alt=""
              width="50"
              class="mx-auto"
            />
          </div>
          <div class="modal-body">
            <div class="text-center">
              <h5 style="color: white; font-weight: 600">
                Apakah anda yakin ingin keluar?
              </h5>
              <p>Anda harus memulai ulang verifikasi</p>
            </div>
            <img
              width="100"
              height="100"
              src="https://img.icons8.com/isometric/100/exit.png"
              alt="exit"
              class="my-3"
            />
            <div class="mb-4">
              <button @click="$emit('close')" class="form_button_danger mr-2">
                Keluar
              </button>
              <button @click="backStepPosition" class="form_button_border">
                Lanjutkan verifikasi
              </button>
            </div>
          </div>
        </div>

        <!-- Finish Verification -->
        <div v-else-if="positionChecker() === 'stepFinish'" class="modal-inner">
          <div class="modal-header mb-2">
            <img
              src="../../../public/images/pgx-logo.png"
              alt=""
              width="50"
              class="mx-auto"
            />
          </div>

          <div class="modal-body px-4">
            <div class="text-center">
              <h5 style="color: white; font-weight: 600">KYC sedang diproses</h5>
              <p>Data Anda telah dikirim dan sedang ditinjau oleh admin.</p>
            </div>

            <img
              width="100"
              height="100"
              src="https://img.icons8.com/isometric/100/checked.png"
              alt="completed"
              class="my-3"
            />

            <div class="info_alert w-100 mb-3">
              <h6 class="text-center mb-3">Dalam proses KYC</h6>
              <p class="mb-0 text-center">
                Mohon menunggu hingga admin menyelesaikan pemeriksaan KYC Anda.
                Anda akan menerima email pemberitahuan setelah KYC disetujui atau ditolak.
              </p>
            </div>

            <div class="mb-4">
              <button
                @click="$emit('close')"
                class="form_button_secondary"
              >
                Tutup
              </button>
            </div>
          </div>
        </div>

        <div v-else class="modal-inner">
          <div class="modal-header">
            <!-- invisible element -->
            <div class="close_button" style="opacity: 0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </div>

            <div class="m-auto">
              <img
                src="../../../public/images/pgx-logo.png"
                alt=""
                width="50"
              />
            </div>

            <button @click="nextStepPosition('stepClose')" class="close_button">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <!-- Agreement -->
            <div v-if="positionChecker() === 'stepAgreement'" class="w-100">
              <div class="body_content">
                <div class="info_alert d-none d-lg-block">
                  <p>
                    Gunakan browser pada ponsel anda untuk menyelesaikan proses
                    verifikasi KYC dengan lebih mudah.
                  </p>
                </div>
                <div class="py-4">
                  <div
                    class="d-flex justify-content-center align-items-center mb-3"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="mr-3"
                    >
                      <path
                        d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"
                      ></path>
                      <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                    </svg>
                    <div>
                      Unggah foto dokumen yang membuktikan identitas Anda
                    </div>
                  </div>
                </div>
                <div class="my-3 px-3" style="height: 4rem; overflow-y: auto">
                  <p style="font-size: 13px">
                    Dengan mengeklik "Mulai", saya mengizinkan Perusahaan dan
                    penyedia layanannya, ASLI RI, untuk memperoleh dan
                    mengungkapkan hasil pindaian geometri wajah dan barcode ID
                    saya untuk tujuan verifikasi identitas saya sesuai dengan
                    Kebijakan Privasi Perusahaan dan ASLI RI dan untuk
                    meningkatkan dan memperbarui produk atau layanan ASLI RI
                    (termasuk algoritmanya). Perusahaan dan ASLI RI akan
                    menyimpan data biometrik untuk jangka waktu tertentu
                    sebagaimana diwajibkan oleh hukum atau selama diperlukan
                    untuk tujuan pengumpulannya.
                  </p>
                </div>
              </div>
              <div class="body_footer">
                <button
                  @click="nextStepPosition('stepPersonalData')"
                  class="form_button w-100"
                >
                  <span>Mulai</span>
                </button>
              </div>
            </div>

            <!-- Step Personal Data (ASLIRI) - Data diri untuk verifikasi biometrik -->
            <div v-if="positionChecker() === 'stepPersonalData'" class="w-100">
              <div class="body_content personal_data_content">
                <div class="px-2">
                  <div class="mb-3">
                    <label
                      >Nama Lengkap (sesuai KTP)
                      <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="asliriForm.name"
                      type="text"
                      class="form_input w-100"
                      placeholder="Nama lengkap sesuai KTP"
                    />
                  </div>

                  <div class="mb-3">
                    <label
                      >Tanggal Lahir <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="asliriForm.birthdate"
                      type="date"
                      class="form_input w-100"
                    />
                    <small style="color: #a5a5a5">Format: YYYY-MM-DD</small>
                  </div>

                  <div class="mb-3">
                    <label
                      >Tempat Lahir <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="asliriForm.birthplace"
                      type="text"
                      class="form_input w-100"
                      placeholder="Kota tempat lahir"
                    />
                  </div>

                  <div class="kyc-address-section mb-3">
                    <h6 class="kyc-address-heading">Alamat sesuai KTP</h6>
                    <KycAddressFields
                      v-model="ktpAddress"
                      :token="token"
                    />
                  </div>

                  <div class="kyc-address-section mb-3">
                    <h6 class="kyc-address-heading">Alamat Domisili</h6>
                    <label class="kyc-checkbox mb-3">
                      <input
                        v-model="domicileSameAsKtp"
                        type="checkbox"
                      />
                      <span>Sama dengan alamat KTP</span>
                    </label>
                    <KycAddressFields
                      v-if="!domicileSameAsKtp"
                      v-model="domicileAddress"
                      :token="token"
                    />
                  </div>

                  <div class="mb-3">
                    <label
                      >Nama Ibu Kandung
                      <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="asliriForm.mother_name"
                      type="text"
                      class="form_input w-100"
                      placeholder="Nama ibu kandung"
                    />
                  </div>

                  <div class="mb-3">
                    <label
                      >NIK <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="asliriForm.other"
                      type="text"
                      class="form_input w-100"
                      placeholder="NIK 16 digit sesuai KTP"
                      maxlength="16"
                      inputmode="numeric"
                    />
                    <small style="color: #a5a5a5">Wajib 16 digit angka</small>
                  </div>

                  <div class="mb-3">
                    <label>NPWP</label>
                    <input
                      v-model="asliriForm.npwp"
                      type="text"
                      class="form_input w-100"
                      placeholder="Nomor NPWP (opsional)"
                      maxlength="20"
                      inputmode="numeric"
                    />
                    <small style="color: #a5a5a5"
                      >Opsional. Isi jika memiliki NPWP.</small
                    >
                  </div>

                  <div class="mb-3">
                    <label
                      >No. Handphone <span class="text-danger">*</span></label
                    >
                    <input
                      v-model="asliriForm.mobilenumber"
                      type="tel"
                      class="form_input w-100"
                      placeholder="Contoh: 081234567890"
                    />
                    <small style="color: #a5a5a5"
                      >Wajib diisi. Gunakan format 08xx atau +62.</small
                    >
                  </div>
                </div>
              </div>
              <div class="body_footer">
                <button
                  @click="nextStepPosition('stepDocument')"
                  class="form_button w-100"
                  :disabled="!isPersonalDataValid"
                >
                  Berikutnya
                </button>
              </div>
            </div>

            <!-- Step one (Document - Foto KTP untuk ASLIRI files_photo) -->
            <div v-if="positionChecker() === 'stepDocument'" class="w-100">
              <div class="body_content">
                <div class="pr-4">
                  <div class="my-2 px-2">
                    <div>
                      <!-- ASLIRI: Hanya perlu satu foto KTP (files_photo) -->
                      <div
                        v-if="stepDocumentFormPosition === 'captureFrontSide'"
                      >
                        <label
                          >Ambil Foto KTP
                          <span class="text-danger"> *</span></label
                        >
                        <div
                          class="img-thumbnail position-relative"
                          :class="!videoStream && 'cursor-pointer'"
                          @click="
                            async () => {
                              await cameraSidesChecker();
                              startVideoStream('environment');
                            }
                          "
                        >
                          <div
                            v-if="!videoStream && !isCameraLoading"
                            class="center_element"
                          >
                            <h6>Klik untuk memulai kamera</h6>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="30"
                              height="30"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            >
                              <path
                                d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
                              ></path>
                              <circle cx="12" cy="13" r="3"></circle>
                            </svg>
                          </div>

                          <div v-if="isCameraLoading" class="center_element">
                            <span
                              class="spinner-border spinner-border-sm"
                              role="status"
                            ></span>
                          </div>

                          <video
                            ref="videoElement"
                            autoplay=""
                            playsinline=""
                            width="100%"
                          ></video>
                        </div>

                        <div class="d-flex justify-content-center mb-2">
                          <button
                            v-if="availableAllCameraSides"
                            @click="
                              () => {
                                stopVideoStream();
                                switchCamera();
                                startVideoStream();
                              }
                            "
                            class="form_button_border"
                            style="padding: 6px 8px"
                          >
                            <svg
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4"
                              />
                            </svg>
                          </button>
                        </div>

                        <button
                          @click="
                            () => {
                              captureImage('stepDocumentcapturedFrontImage');
                              stopVideoStream();
                              stepDocumentFormPosition = 'captureResult';
                            }
                          "
                          class="form_button"
                          :disabled="!videoStream"
                        >
                          Ambil Foto KTP
                        </button>
                      </div>

                      <div
                        v-else-if="stepDocumentFormPosition === 'captureResult'"
                      >
                        <div class="mb-3">
                          <label>Foto KTP</label>
                          <img
                            :src="stepDocumentcapturedFrontImage"
                            alt=""
                            class="img-thumbnail"
                          />
                        </div>
                        <button
                          @click="
                            () => {
                              stepDocumentcapturedFrontImage = '';
                              stepDocumentFormPosition = 'captureFrontSide';
                            }
                          "
                          class="form_button_secondary"
                        >
                          Ulangi
                        </button>
                      </div>
                    </div>

                    <div
                      v-if="stepDocumentFormPosition !== 'captureResult'"
                      class="info_alert mt-3"
                    >
                      <p>
                        Silahkan ambil foto <i>KTP</i> Anda dengan jelas dan
                        lengkap. Pastikan informasi pada dokumen terlihat jelas
                        dan tidak terpotong.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="body_footer">
                <button
                  @click="nextStepPosition('stepBiometric')"
                  class="form_button w-100"
                  :disabled="!stepDocumentcapturedFrontImage"
                >
                  Berikutnya
                </button>
                <p class="mt-3 mb-0" style="font-size: 12px; color: #a5a5a5">
                  Verifikasi Dokumen - Langkah 1 dari 2
                </p>
              </div>
            </div>

            <!-- Step two (Biometric Verification) -->
            <div v-if="positionChecker() === 'stepBiometric'" class="w-100">
              <div class="body_content">
                <div v-if="stepBiometricFormPosition === 'captureImage'">
                  <div
                    class="img-thumbnail position-relative"
                    :class="!videoStream && 'cursor-pointer'"
                    @click="startVideoStream('user')"
                  >
                    <div
                      v-if="!videoStream && !isCameraLoading"
                      class="center_element"
                    >
                      <h6>Klik untuk memulai kamera</h6>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
                        ></path>
                        <circle cx="12" cy="13" r="3"></circle>
                      </svg>
                    </div>

                    <div v-if="isCameraLoading" class="center_element">
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                      ></span>
                    </div>

                    <video
                      ref="videoElement"
                      autoplay=""
                      playsinline=""
                      width="100%"
                    ></video>
                  </div>

                  <div class="d-flex justify-content-center mb-2">
                    <button
                      v-if="availableAllCameraSides"
                      @click="
                        () => {
                          stopVideoStream();
                          switchCamera();
                          startVideoStream();
                        }
                      "
                      class="form_button_border"
                      style="padding: 6px 8px"
                    >
                      <svg
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M17.651 7.65a7.131 7.131 0 0 0-12.68 3.15M18.001 4v4h-4m-7.652 8.35a7.13 7.13 0 0 0 12.68-3.15M6 20v-4h4"
                        />
                      </svg>
                    </button>
                  </div>

                  <button
                    @click="
                      () => {
                        captureImage('stepBiometricCapturedImage');
                        stopVideoStream();
                        stepBiometricFormPosition = 'captureImageResult';
                      }
                    "
                    class="form_button"
                    :disabled="!videoStream"
                  >
                    Ambil
                  </button>

                  <div class="info_alert mt-3">
                    <p>
                      Silahkan lakukan pemindaian wajah Anda dengan pencahayaan
                      yang baik dan pastikan wajah terlihat jelas, tanpa ada
                      objek yang menghalangi.
                    </p>
                  </div>
                </div>

                <div v-if="stepBiometricFormPosition === 'captureImageResult'">
                  <img
                    :src="stepBiometricCapturedImage"
                    alt=""
                    class="img-thumbnail"
                  />
                  <button
                    @click="stepBiometricFormPosition = 'captureImage'"
                    class="form_button"
                  >
                    Ulangi
                  </button>
                </div>
              </div>
              <div class="body_footer">
                <button
                  @click="nextStepPosition('stepReview')"
                  class="form_button w-100"
                  :disabled="!stepBiometricCapturedImage"
                >
                  <span>Tinjau Informasi</span>
                </button>
                <p class="mt-3 mb-0" style="font-size: 12px; color: #a5a5a5">
                  Verifikasi Biometrik - Langkah 2 dari 2
                </p>
              </div>
            </div>

            <!-- Review semua informasi sebelum dikirim ke ASLIRI -->
            <div v-if="positionChecker() === 'stepReview'" class="w-100">
              <div class="review_header px-4 pb-3">
                <h4>Review Informasi KYC</h4>
                <p>
                  Pastikan seluruh data dan foto sudah benar sebelum dikirim
                  untuk verifikasi.
                </p>
              </div>

              <div class="body_content review_content">
                <section class="review_section">
                  <h6>Data Pribadi</h6>
                  <div class="review_data_grid">
                    <div class="review_item">
                      <span>Nama Lengkap</span>
                      <strong>{{ asliriForm.name }}</strong>
                    </div>
                    <div class="review_item">
                      <span>Tanggal Lahir</span>
                      <strong>{{ asliriForm.birthdate }}</strong>
                    </div>
                    <div class="review_item">
                      <span>Tempat Lahir</span>
                      <strong>{{ asliriForm.birthplace }}</strong>
                    </div>
                    <div class="review_item">
                      <span>Nama Ibu Kandung</span>
                      <strong>{{ asliriForm.mother_name }}</strong>
                    </div>
                    <div class="review_item review_item_full">
                      <span>Alamat KTP</span>
                      <strong>{{ ktpAddressText }}</strong>
                    </div>
                    <div class="review_item review_item_full">
                      <span>Alamat Domisili</span>
                      <strong>{{
                        domicileSameAsKtp
                          ? "Sama dengan alamat KTP"
                          : domicileAddressText
                      }}</strong>
                    </div>
                    <div class="review_item">
                      <span>NIK</span>
                      <strong>{{ asliriForm.other }}</strong>
                    </div>
                    <div v-if="asliriForm.npwp" class="review_item">
                      <span>NPWP</span>
                      <strong>{{ asliriForm.npwp }}</strong>
                    </div>
                    <div class="review_item">
                      <span>No. Handphone</span>
                      <strong>{{ asliriForm.mobilenumber }}</strong>
                    </div>
                  </div>
                </section>

                <section class="review_section">
                  <h6>Dokumen dan Biometrik</h6>
                  <div class="review_photo_grid">
                    <div class="review_photo">
                      <span>Foto KTP</span>
                      <img
                        :src="stepDocumentcapturedFrontImage"
                        alt="Foto KTP"
                      />
                    </div>
                    <div class="review_photo">
                      <span>Foto Selfie</span>
                      <img
                        :src="stepBiometricCapturedImage"
                        alt="Foto selfie"
                      />
                    </div>
                  </div>
                </section>
              </div>

              <div class="body_footer review_footer">
                <button
                  @click="editKycInformation"
                  class="form_button_secondary"
                  :disabled="isLoading"
                >
                  Edit Informasi
                </button>
                <button
                  @click="postAsliriVerification"
                  class="form_button"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm mr-2"
                    role="status"
                  ></span>
                  <span>{{
                    isLoading ? "Mengirim..." : "Kirim Verifikasi"
                  }}</span>
                </button>
              </div>
            </div>

            <!-- Verification Error -->
            <div v-if="positionChecker() === 'stepError'" class="w-100">
              <div class="body_content">
                <div class="error_alert">
                  <div class="mr-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" x2="12" y1="8" y2="12"></line>
                      <line x1="12" x2="12.01" y1="16" y2="16"></line>
                    </svg>
                  </div>
                  <div>
                    <h6>Error</h6>
                    <p>{{ errorMessage }}</p>
                  </div>
                </div>

                <div v-if="asliriResult.selfieScore" class="info_alert mt-3">
                  <h6 class="text-center mb-3">
                    Hasil Verifikasi Biometrik ASLIRI
                  </h6>

                  <div class="mb-2">
                    <strong
                      >Kemiripan Wajah (Selfie):
                      {{ asliriResult.selfieScore }}</strong
                    >
                    <div class="score_bar_container mt-1">
                      <div
                        class="score_bar"
                        :style="{ width: asliriResult.selfieScore }"
                      ></div>
                    </div>
                  </div>

                  <div>
                    <strong
                      >Kesesuaian Nama: {{ asliriResult.nameScore }}</strong
                    >
                    <div class="score_bar_container mt-1">
                      <div
                        class="score_bar"
                        :style="{ width: asliriResult.nameScore }"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="body_footer">
                <button
                  @click="
                    () => {
                      resetState();
                      backStepPosition();
                    }
                  "
                  class="form_button_secondary align-self-start"
                >
                  Ulangi
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
// node_modules
import Cookies from "js-cookie";
import { useToast } from "vue-toastification";

// applibs
import thestore from "@/applibs/thestore.js";
import themain from "@/applibs/themain.js";

// components
import KycAddressFields from "./KycAddressFields.vue";

const emptyAddress = () => ({
  provinceCode: "",
  provinceName: "",
  regencyCode: "",
  regencyName: "",
  districtCode: "",
  districtName: "",
  villageCode: "",
  villageName: "",
  postalCode: "",
  street: "",
});

const toast = useToast();
export default {
  components: {
    KycAddressFields,
  },
  props: {
    show: Boolean,
  },

  data() {
    return {
      themain,
      token: Cookies.get("jwt") || Cookies.get("usid"),

      // Form data untuk ASLIRI Biometric Plus Verification
      asliriForm: {
        name: "",
        birthdate: "",
        birthplace: "",
        mother_name: "",
        other: "",
        npwp: "",
        mobilenumber: "",
      },
      ktpAddress: emptyAddress(),
      domicileAddress: emptyAddress(),
      domicileSameAsKtp: true,

      // Hasil verifikasi ASLIRI
      asliriResult: {
        selfieScore: "",
        nameScore: "",
        motherNameScore: "",
        pdob: "",
      },

      stepPosition: ["stepAgreement"],
      stepDocumentFormPosition: "captureFrontSide",
      stepDocumentcapturedFrontImage: "",
      stepDocumentcapturedFrontImageBlob: "",
      stepBiometricFormPosition: "captureImage",
      stepBiometricCapturedImage: "",
      stepBiometricCapturedImageBlob: "",

      videoStream: null,
      availableAllCameraSides: false,
      facingMode: "user",
      errorMessage: "",
      isLoading: false,
      isCameraLoading: false,
    };
  },

  computed: {
    ktpAddressText() {
      return this.composeAddress(this.ktpAddress);
    },
    domicileAddressText() {
      return this.domicileSameAsKtp
        ? this.ktpAddressText
        : this.composeAddress(this.domicileAddress);
    },
    isPersonalDataValid() {
      const nik = String(this.asliriForm.other || "").replace(/\D/g, "");
      const phone = String(this.asliriForm.mobilenumber || "").trim();
      return !!(
        this.asliriForm.name &&
        this.asliriForm.birthdate &&
        this.asliriForm.birthplace &&
        this.isAddressComplete(this.ktpAddress) &&
        (this.domicileSameAsKtp || this.isAddressComplete(this.domicileAddress)) &&
        this.asliriForm.mother_name &&
        nik.length === 16 &&
        phone
      );
    },
  },

  methods: {
    // Verifikasi biometrik menggunakan ASLIRI (Biometric Plus Verification)
    // Mengirimkan semua data dalam satu panggilan API:
    // - Data diri: name, birthdate, birthplace, address, mother_name, other (NIK), mobilenumber
    // - files_photo: foto KTP dalam format Base64 (dari stepDocument)
    // - selfie_photo: foto selfie dalam format Base64 (dari stepBiometric)
    async postAsliriVerification() {
      this.isLoading = true;

      try {
        // Ekstrak Base64 dari data URL (hapus prefix "data:image/png;base64,")
        const filesPhotoBase64 =
          this.stepDocumentcapturedFrontImage.split(",")[1];
        const selfiePhotoBase64 = this.stepBiometricCapturedImage.split(",")[1];

        const payload = {
          ...this.asliriForm,
          address: this.ktpAddressText,
          address_detail: this.ktpAddress.street,
          address_village: this.ktpAddress.villageName,
          address_district: this.ktpAddress.districtName,
          address_regency: this.ktpAddress.regencyName,
          address_province: this.ktpAddress.provinceName,
          address_postal_code: this.ktpAddress.postalCode,
          domicile_same_as_ktp: this.domicileSameAsKtp,
          domicile: this.domicileAddressText,
          domicile_detail: this.domicileSameAsKtp
            ? this.ktpAddress.street
            : this.domicileAddress.street,
          domicile_village: this.domicileSameAsKtp
            ? this.ktpAddress.villageName
            : this.domicileAddress.villageName,
          domicile_district: this.domicileSameAsKtp
            ? this.ktpAddress.districtName
            : this.domicileAddress.districtName,
          domicile_regency: this.domicileSameAsKtp
            ? this.ktpAddress.regencyName
            : this.domicileAddress.regencyName,
          domicile_province: this.domicileSameAsKtp
            ? this.ktpAddress.provinceName
            : this.domicileAddress.provinceName,
          domicile_postal_code: this.domicileSameAsKtp
            ? this.ktpAddress.postalCode
            : this.domicileAddress.postalCode,
          selfie_photo: selfiePhotoBase64,
          files_photo: filesPhotoBase64,
        };

        const res = await thestore.postKycAsliriVerify(this.token, payload);

        if (res.kyc_status === "pending") {
          if (this.emitter) this.emitter.emit("kyc-submitted");
          this.nextStepPosition("stepFinish");
          return;
        }

        this.errorMessage =
          res.message || "Pengajuan KYC gagal. Silakan coba lagi.";
        this.nextStepPosition("stepError");
      } catch (error) {
        console.error("ASLIRI Error:", error);
        const msg =
          error?.response?.data?.message ||
          error?.response?.data?.msg ||
          (error?.response?.status === 204
            ? "Sesi tidak valid atau token kadaluarsa. Silakan login ulang."
            : null);
        this.errorMessage = msg || "Terjadi kesalahan saat verifikasi";
        this.nextStepPosition("stepError");
        toast.error(this.errorMessage);
      } finally {
        this.isLoading = false;
      }
    },

    composeAddress(addr) {
      const parts = [
        addr.street,
        addr.villageName ? `Kel. ${addr.villageName}` : "",
        addr.districtName ? `Kec. ${addr.districtName}` : "",
        addr.regencyName,
        addr.provinceName,
      ]
        .map((part) => String(part || "").trim())
        .filter(Boolean);
      const postal = String(addr.postalCode || "").trim();
      return [parts.join(", "), postal].filter(Boolean).join(" ").trim();
    },
    isAddressComplete(addr) {
      return !!(
        addr.provinceCode &&
        addr.regencyCode &&
        addr.districtCode &&
        addr.villageCode &&
        addr.street &&
        /^\d{5}$/.test(String(addr.postalCode || ""))
      );
    },

    nextStepPosition(nextStep) {
      this.stepPosition.push(nextStep);
    },

    backStepPosition() {
      this.stepPosition.pop();
    },

    positionChecker() {
      return this.stepPosition[this.stepPosition.length - 1];
    },

    editKycInformation() {
      this.stepPosition = ["stepAgreement", "stepPersonalData"];
    },

    resetState() {
      this.stepDocumentFormPosition = "captureFrontSide";
      this.stepDocumentcapturedFrontImage = "";
      this.stepDocumentcapturedFrontImageBlob = "";
      this.stepBiometricFormPosition = "captureImage";
      this.stepBiometricCapturedImage = "";
      this.stepBiometricCapturedImageBlob = "";
      this.asliriResult = {
        selfieScore: "",
        nameScore: "",
        motherNameScore: "",
        pdob: "",
      };
      this.videoStream = null;
      this.errorMessage = "";
      this.isLoading = false;

      if (this.positionChecker() !== "stepError")
        this.stepPosition = ["stepAgreement"];
    },

    async startVideoStream(facingMode) {
      if (this.isCameraLoading) return;

      this.isCameraLoading = true;

      try {
        if (!this.videoStream) {
          if (facingMode && this.availableAllCameraSides)
            this.facingMode = facingMode;

          const options = {
            audio: false,
            video: this.availableAllCameraSides
              ? {
                  facingMode: { exact: this.facingMode },
                  width: { ideal: 640 },
                  height: { ideal: 640 },
                }
              : {
                  width: { ideal: 640 },
                  height: { ideal: 640 },
                },
          };

          try {
            const videoElement = this.$refs.videoElement;
            this.videoStream = await navigator.mediaDevices.getUserMedia(
              options
            );
            videoElement.srcObject = this.videoStream;
          } catch (error) {
            console.error("Error accessing the camera: ", error);
            this.nextStepPosition("stepError");
            this.errorMessage = "Kamera tidak dapat diakses. Tolong sambungkan";
          }
        }
      } finally {
        this.isCameraLoading = false;
      }
    },

    stopVideoStream() {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach((track) => track.stop());
        this.videoStream = null;
      }
    },

    captureImage(imageStepState) {
      const video = this.$refs.videoElement;
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext("2d");
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      this[imageStepState] = canvas.toDataURL("image/png");

      canvas.toBlob((blob) => {
        this[`${imageStepState}Blob`] = blob;
      }, "image/png");
    },

    async cameraSidesChecker() {
      const supports = navigator.mediaDevices.getSupportedConstraints();

      if (!supports["facingMode"]) return;

      let frontCamera = null;
      let rearCamera = null;

      try {
        frontCamera = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: { exact: "user" } },
        });
        frontCamera.getTracks().forEach((track) => track.stop());
        rearCamera = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: { exact: "environment" } },
        });
        rearCamera.getTracks().forEach((track) => track.stop());
      } catch (error) {
        console.error("Camera error: ", error);
      }

      if (frontCamera && rearCamera) this.availableAllCameraSides = true;
    },

    switchCamera() {
      this.facingMode = this.facingMode === "user" ? "environment" : "user";
    },

    navigateToAgreement() {
      this.$router.push("/settings/agreement-sign");
    },

    isKycScrollableTarget(target) {
      return target instanceof Element && Boolean(target.closest(".body_content"));
    },

    preventBackgroundScroll(event) {
      if (!this.isKycScrollableTarget(event.target)) {
        event.preventDefault();
      }
    },

    lockBodyScroll() {
      if (this.bodyScrollLocked) return;

      this.bodyScrollLocked = true;
      this.savedScrollY = window.scrollY;
      this.savedHtmlOverflow = document.documentElement.style.overflow;
      this.savedBodyOverflow = document.body.style.overflow;
      this.savedBodyPosition = document.body.style.position;
      this.savedBodyTop = document.body.style.top;
      this.savedBodyWidth = document.body.style.width;
      this.savedBodyLeft = document.body.style.left;
      this.savedBodyRight = document.body.style.right;
      this.onBackgroundScroll = (event) => this.preventBackgroundScroll(event);

      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${this.savedScrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";

      document.addEventListener("wheel", this.onBackgroundScroll, {
        passive: false,
      });
      document.addEventListener("touchmove", this.onBackgroundScroll, {
        passive: false,
      });
    },

    unlockBodyScroll() {
      if (!this.bodyScrollLocked) return;

      this.bodyScrollLocked = false;
      document.documentElement.style.overflow = this.savedHtmlOverflow || "";
      document.body.style.overflow = this.savedBodyOverflow || "";
      document.body.style.position = this.savedBodyPosition || "";
      document.body.style.top = this.savedBodyTop || "";
      document.body.style.left = this.savedBodyLeft || "";
      document.body.style.right = this.savedBodyRight || "";
      document.body.style.width = this.savedBodyWidth || "";
      document.removeEventListener("wheel", this.onBackgroundScroll);
      document.removeEventListener("touchmove", this.onBackgroundScroll);
      this.onBackgroundScroll = null;
      window.scrollTo(0, this.savedScrollY || 0);
    },
  },

  watch: {
    show(newVal) {
      if (newVal) {
        this.lockBodyScroll();
        return;
      }

      this.unlockBodyScroll();
      this.stopVideoStream();
      this.resetState();
    },
  },

  mounted() {
    if (this.show) this.lockBodyScroll();
  },

  beforeUnmount() {
    this.unlockBodyScroll();
  },
};
</script>

<style scoped>
button {
  border: none;
  border-radius: 5px;
  outline: none;
  transition: all 0.2s ease;
  background-color: transparent;
}
button:disabled {
  background-color: #191d2c;
  color: #d3d3d3;
}
button:disabled:hover {
  background-color: #191d2c;
}

label {
  font-weight: 600;
  color: #dadada;
}

p {
  margin: 0;
}

input[type="file"] {
  padding: 8px 12px;
  border: 1px solid #e4e4e7;
  border-radius: 5px;
}
input[type="file"]:hover {
  cursor: pointer;
}
input[type="file"]::file-selector-button {
  border: none;
  font-weight: 600;
  color: #dadada;
  background-color: transparent;
}

.form_input {
  padding: 8px 12px;
  background-color: #1e2435;
  border: 1px solid #2e3447;
  border-radius: 5px;
  color: #dadada;
  outline: none;
  margin-top: 4px;
}
.form_input:focus {
  border-color: #fedba1;
}
.form_input::placeholder {
  color: #5a5f72;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  overscroll-behavior: none;
  transition: opacity 0.3s ease;
}

.modal-container .modal-body {
  color: #bbbbbb;
}

.modal-container {
  width: 100%;
  max-width: 24rem;
  max-height: 70vh;
  margin: auto;
  padding: 0;
  background-color: #131722;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-inner {
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: 70vh;
  width: 100%;
  overflow: hidden;
}

.modal-container.review_modal {
  max-width: 58rem;
}

.modal-container.personal_data_modal {
  max-width: 28rem;
}

.modal-header {
  display: flex;
  align-items: stretch;
  flex-shrink: 0;
  border: none;
}

.close_button {
  width: 2.5rem;
  height: 2.5rem;
}
.close_button:hover {
  background-color: #ffffff2c;
}
.close_button svg {
  width: 1rem;
  height: 1rem;
  color: #e4e4e7;
}

.modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 auto;
  min-height: 0;
  padding: 0;
  color: #71717a;
  overflow: hidden;
}

.modal-body > .w-100 {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}

.body_content {
  padding: 1.5rem;
  padding-top: 0;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
}

.kyc-address-heading {
  margin-bottom: 0.75rem;
  color: #fedba1;
  font-weight: 600;
  font-size: 0.95rem;
}

.kyc-address-section {
  padding-top: 0.5rem;
  border-top: 1px solid #2e3447;
}

.kyc-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  color: #dadada;
  cursor: pointer;
}

.kyc-checkbox input {
  width: 1rem;
  height: 1rem;
  accent-color: #fedba1;
}

.body_footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  padding: 1.5rem;
  padding-top: 0;
}

.review_header {
  flex-shrink: 0;
  color: #dadada;
}

.review_header h4 {
  margin-bottom: 0.35rem;
  font-weight: 600;
}

.review_header p {
  color: #a5a5a5;
}

.review_content {
  padding: 0 1.5rem 1.5rem;
}

.review_section {
  padding: 1.25rem;
  border: 1px solid #2e3447;
  border-radius: 8px;
  background-color: #191d2c;
}

.review_section + .review_section {
  margin-top: 1rem;
}

.review_section h6 {
  margin-bottom: 1rem;
  color: #fedba1;
  font-weight: 600;
}

.review_data_grid,
.review_photo_grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.review_item {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.review_item_full {
  grid-column: 1 / -1;
}

.review_item span,
.review_photo > span {
  margin-bottom: 0.35rem;
  color: #8f96a8;
  font-size: 0.8rem;
}

.review_item strong {
  color: #f0f0f0;
  overflow-wrap: anywhere;
}

.review_photo {
  display: flex;
  flex-direction: column;
}

.review_photo img {
  width: 100%;
  height: 260px;
  border: 1px solid #2e3447;
  border-radius: 6px;
  background-color: #10131d;
  object-fit: contain;
}

.review_footer {
  flex-direction: row;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 1rem;
  border-top: 1px solid #2e3447;
}

.review_footer button {
  min-width: 10rem;
}

.form_button {
  margin-top: 0.5rem;
  padding: 8px 16px;
  background-color: #fedba1;
  color: #f0f0f0;
}
.form_button:hover {
  background-color: #00865a;
}

.form_button_secondary {
  margin-top: 0.5rem;
  padding: 8px 16px;
  background-color: #6d6d6d;
  color: #f7f7f7;
}
.form_button_secondary:hover {
  background-color: #636363;
}

.form_button_danger {
  margin-top: 0.5rem;
  padding: 8px 16px;
  background-color: #ff4c4c;
  color: #f0f0f0;
}
.form_button_danger:hover {
  background-color: #f05656;
}

.form_button_border {
  margin-top: 0.5rem;
  padding: 8px 16px;
  border: 1px solid #e4e4e7;
  color: #f0f0f0;
}
.form_button_border:hover {
  background-color: #ffffff17;
}

.error_alert {
  display: flex;
  padding: 16px;
  border: 1px solid #ee58587c;
  border-radius: 5px;
  color: #ff4c4c;
}
.error_alert svg {
  width: 1rem;
  height: 1rem;
}
.error_alert h6 {
  margin: 0;
  font-weight: 600;
}
.error_alert p {
  margin: 0;
}
.info_alert {
  display: flex;
  flex-direction: column;
  padding: 16px;
  border: 1px solid #dadada77;
  border-radius: 5px;
  color: #dadada;
  background-color: #c0d4ff17;
}
.info_alert h6 {
  margin: 0;
  font-weight: 600;
}

.center_element {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-wrap: nowrap;
  text-align: center;
}

.score_bar_container {
  width: 100%;
  height: 0.75rem;
  background-color: #fedba150;
}
.score_bar {
  height: 100%;
  background-color: #fedba1;
}

.img-thumbnail {
  background-color: #1e2435;
  border-color: #1e2435;
}

.modal-default-button {
  float: right;
}

/*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media only screen and (max-width: 550px) {
  .modal-container.review_modal {
    width: calc(100% - 1rem);
  }

  .review_data_grid,
  .review_photo_grid {
    grid-template-columns: 1fr;
  }

  .review_item_full {
    grid-column: auto;
  }

  .review_photo img {
    height: 210px;
  }

  .review_footer {
    flex-direction: column-reverse;
  }

  .review_footer button {
    width: 100%;
  }
}
</style>
